(function () {
  'use strict';

  const POPUP_SELECTOR = 'popup-component';
  const POPUP_CLOSE_SELECTOR = '[data-popup-close]';
  const NOTIFICATION_FORM_SELECTOR = '[data-notification-form]';
  const NOTIFICATION_HEADING_SELECTOR = '[data-product-notification-heading]';
  const HAS_SUCCESS_CLASS = 'has-success';

  if (customElements.get('product-notification')) return;

  customElements.define('product-notification', class extends HTMLElement {
    constructor() {
      super();
      this.notificationForm = this.querySelector(NOTIFICATION_FORM_SELECTOR);
      this.popup = this.closest('dialog');
      this.popupClose = this.popup.querySelector(POPUP_CLOSE_SELECTOR);
    }

    connectedCallback() {
      this.notificationForm.addEventListener('submit', (ev) => this.handleSubmit(ev));
      this.popupClose.addEventListener('click', () => this.resetStorage());
    }

    async handleSubmit(ev) {
      ev.preventDefault();

      const form = this.notificationForm;
      const emailInput = form.querySelector('input[name="email"]');
      const email = emailInput ? emailInput.value.trim() : '';
      const variantId = form.dataset.variantId;
      const publicKey = form.dataset.klaviyoPublicKey;

      if (!email || !variantId || !publicKey) return;

      const submitBtn = form.querySelector('[type="submit"]');
      submitBtn.disabled = true;

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(
          'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(publicKey),
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify(payload),
            keepalive: true
          }
        );

        if (response.ok || response.status === 202) {
          const heading = this.querySelector(NOTIFICATION_HEADING_SELECTOR);
          if (heading) heading.style.display = 'none';

          const successMsg = this.querySelector('[data-notification-success]');
          if (successMsg) successMsg.style.display = '';

          const popupComponent = this.closest(POPUP_SELECTOR);
          if (popupComponent) popupComponent.classList.add(HAS_SUCCESS_CLASS);

          this.writeStorage(form.id);
        } else {
          const errorMsg = this.querySelector('[data-notification-error]');
          if (errorMsg) errorMsg.style.display = '';
        }
      } catch (err) {
        const errorMsg = this.querySelector('[data-notification-error]');
        if (errorMsg) errorMsg.style.display = '';
      } finally {
        submitBtn.disabled = false;
      }
    }

    writeStorage(id) {
      if (typeof window.sessionStorage !== 'undefined') {
        window.sessionStorage.setItem('notification_form_id', id);
      }
    }

    resetStorage() {
      window.sessionStorage.removeItem('notification_form_id');
    }
  });
})();
